/* eslint-disable */
$ = jQuery;
 
var mafs = $(".usedmachines-archive"); 
var mafsForm = mafs.find("form"); 
 
mafsForm.submit(function(e){
    e.preventDefault(); 
 
    if(mafsForm.find("#search").val().length !== 0) {
        var search = mafsForm.find("#search").val();
    }

    if(mafsForm.find("#genre").val().length !== 0) {
        var genre = mafsForm.find("#genre").val();
    }

    var price = price
     
    var data = {
        action : "my_ajax_filter_search",
        search : search,
        genre : genre,
        price : price
    } 

    $.ajax({
        url : ajax_url,
        data : data,
        beforeSend:function(){
          $(".lds-default").addClass('loading');
        },
        success : function(response) {
          $(".lds-default").removeClass('loading');
            mafs.find("#response").empty();
            if(response) {
                for(var i = 0 ;  i < response.length ; i++) {
                     var html  = "<div class='column is-3-fullhd is-4-desktop is-6-tablet is-12-mobile usedmachine-archive-column'>";
                         html  += "<div class='usedmachine-card'>";
                         html  += "<a class='usedmachine-thumbnail-link' href='" + response[i].permalink + "'>";
                         
                         html  += "<div class='usedmachine-thumbnail-wrapper'>";
                         html  +=   "<div class='usedmachine-thumbnail' style='background: url(" + response[i].poster + ")' alt='" + response[i].title + "'>";
                         html  +=   "</div>";
                         html  += "</div>";
                         html  += "</a>";

                         html  += "<div class='inner-column'>";
                         html  +=    "<div class='text'>";
                         html  +=        "<h3><a class='usedmachine-title-link' href='" + response[i].permalink + "'>" + response[i].title + "</a></h3>";
                         html  +=        "<h4>" + response[i].price + "</h4>";
                         html  +=    "<a class='button-green' href='" + response[i].permalink + "'>Meer informatie</a>";
                         html  +=   "</div>";
                         html  += "</div>";

                         html += "</div>";
                         html += "</div>";
                    mafs.find("#response").append(html);
                }
            } else {
                var html  = "<div class='no-result notification is-warning'>Geen machines gevonden. Probeer een andere zoekopdracht.</div>";
                mafs.find("#response").append(html);
            }
        },
        error: function(xhr) {
          mafs.find("#response").empty();
          var html  = "<div class='no-result notification is-warning'>Geen machines gevonden. Probeer een andere zoekopdracht.</div>";
          mafs.find("#response").append(html);
          $(".lds-default").removeClass('loading');
        }
    });
});
